// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PingAnswerStyles-cls1___277825b22dcfd1e1c19{/*!*/}.PingAnswerStyles-cls2__eba91ac7f15533ccdd30{display:flex;flex-direction:row;padding:8px 0px 8px 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PingAnswerStyles-cls1___277825b22dcfd1e1c19",
	"cls2": "PingAnswerStyles-cls2__eba91ac7f15533ccdd30 PingAnswerStyles-cls1___277825b22dcfd1e1c19"
};
export default ___CSS_LOADER_EXPORT___;
